export const N550_CENTER = { lat: 42.46, lng: -8.63 };
export const N550_DEFAULT_ZOOM = 11;

export const SEGMENT_OPACITY = Object.freeze({
  NORMAL: 0.8,
  SELECTED: 1.0,
});

export const SEGMENT_WEIGHTS = Object.freeze({
  NORMAL: 5,
  SELECTED: 9,
});

export const SEGMENT_Z_INDEX = Object.freeze({
  NORMAL: 1,
  SELECTED: 10,
});
